import React, { useEffect } from 'react';
import clsx from 'clsx'
import Card from '@mui/material/Card';
import Lottie from 'react-lottie';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Avatar, Typography, CardContent, Grid } from '@mui/material'
import animationData from './time.json';
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { authActions, dashboardAction } from '_actions'
import { makeStyles } from '@mui/styles'
import { styled } from '@mui/material/styles';
import theme from './../../../../theme'

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    marginLeft: 10,
    marginRight: 10,
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  title: {
    fontWeight: 500,
    color: theme.palette.primary.main
  }
}));

const CustomAvatar = styled(Avatar)({
  height: 45,
  width: 45,
  backgroundColor: '#FFC107',
  [theme.breakpoints.down('md')]: {
    height: 35,
    width: 35,
    display: 'flex'
  },
})

const CardHorasRecebimentoOrcamentos = (props) => {
  const { className, ...rest } = props
  const classes = useStyles();
  const dispatch = useDispatch();

  const horasRecebimentoOrcamentos = useSelector((state) => (state.dashboard ? state.dashboard.dashboard.horasRecebimentoOrcamentos : undefined))

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <Grid container justifyContent="space-between">
          <Grid item styles={{ display: 'flex', flexDirection: 'column' }}>
            <Grid item sx={{ display: 'flex', flexDirection: 'row', alignContent: 'end' }}>
              <Typography variant="h5" className={classes.title}>
                {horasRecebimentoOrcamentos ? horasRecebimentoOrcamentos : ''}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="caption" gutterBottom>
                Horas para {authActions.isEmpresa() ? 'enviar' : 'receber'} orçamentos
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <CustomAvatar>
              <AccessTimeIcon sx={{ fontSize: 25, color: '#000' }} />
            </CustomAvatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card >
  );
}

CardHorasRecebimentoOrcamentos.propTypes = {
  className: PropTypes.string,
  subtitle: PropTypes.string
}

export default CardHorasRecebimentoOrcamentos
